import { TransactionType } from "../graphql/generated/schemas";

// Amount sign filter (not in generated GraphQL types)
export enum AmountSign {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}

// Sort options (not in generated GraphQL types)
export enum SortBy {
  AMOUNT = "AMOUNT",
  CREATED_AT = "CREATED_AT",
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

// Local component state interfaces
export interface FilterState {
  search: string | null;
  amountSign: AmountSign | null;
  minAmount: number | null;
  maxAmount: number | null;
  createdFrom: string | null;
  createdTo: string | null;
  types: TransactionType[];
  orderId: number | null;
  storeId: number | null;
}

export interface SortState {
  sortBy: SortBy;
  sortOrder: SortOrder;
}

export interface PaginationState {
  current: number;
  pageSize: number;
  total: number;
}

